<script>
  import Price from '../../price/src/index.vue';
  export default {
    data(){ return { }},
    setup(){return { Price}}
  };
</script>
<template>
</template>